import { render, staticRenderFns } from "./Measurements.vue?vue&type=template&id=5d1b8c07&scoped=true&"
import script from "./Measurements.vue?vue&type=script&lang=js&"
export * from "./Measurements.vue?vue&type=script&lang=js&"
import style0 from "./Measurements.vue?vue&type=style&index=0&id=5d1b8c07&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d1b8c07",
  null
  
)

export default component.exports